import LoadingSlotsIndicator from './LoadingSlotsIndicator';

export default LoadingSlotsIndicator;
